export const DEFAULT_RATE_DISPLAY_DECIMAL_LIMIT = 2;

/**
 * Techo de la búsqueda dinámica de precisión para un par que NO es stablecoin
 * (ver `getRateDetailPrecision`): la precisión sube de a un decimal desde el
 * default mientras el spread mostrado redondee a cero, y este valor es el
 * límite de esa búsqueda.
 */
export const MAX_RATE_DISPLAY_DECIMAL_LIMIT = 6;

/**
 * Monedas que activan el gate de precisión adaptada en
 * `getStablecoinAwareRateDecimals`, `getStablecoinBreakdownDecimals` y
 * `getDisplayedRateDetailsValues`: ahí los pares fiat siguen la precisión
 * dinámica normal (hasta `MAX_RATE_DISPLAY_DECIMAL_LIMIT`) y solo los
 * stablecoins (cercanos a 1:1, donde esa precisión oculta diferencias reales)
 * usan los decimales del backend hasta `STABLECOIN_MAX_RATE_DISPLAY_DECIMAL_LIMIT`.
 */
export const STABLECOIN_RATE_CURRENCIES = new Set<string>(['USDT', 'USDC']);

/**
 * Única moneda fiat contra la que un stablecoin activa la precisión
 * adaptativa. El par stablecoin<->fiat solo es ~1:1 (y por lo tanto necesita
 * más decimales para revelar el spread) cuando el fiat es USD; contra
 * cualquier otra moneda (CLP, COP, ARS...) el par ya tiene una diferencia de
 * escala grande y el spread es visible con la precisión dinámica normal.
 */
export const STABLECOIN_RATE_FIAT_ANCHOR_CURRENCY = 'USD';

/**
 * Techo de precisión para Spot / Spread / Global66 cuando el par involucra
 * stablecoins. No es un valor fijo ni un objetivo: la precisión mostrada se
 * adapta a los decimales reales que envió el backend, y este número solo
 * acota cuánto detalle puede pedir un valor legítimo.
 *
 * No es la defensa contra el ruido de punto flotante: un valor redondeado en
 * float de 32 bits trae más decimales que el techo y acotarlo igual mostraría
 * ruido. De eso se ocupa la detección de artefacto de
 * `getStablecoinAwareRateDecimals`, en las tasas que se renderizan solas.
 */
export const STABLECOIN_MAX_RATE_DISPLAY_DECIMAL_LIMIT = 11;
